var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-more"},[_c('div',{staticClass:"load-area"},[_c('loading',{attrs:{"boxSize":[36,36]}}),_c('span',[_vm._v("加载中...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }